const juventus = [
  {
    id: 1,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2025", "2025 juventus", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/25-26-01/uni0.png",
      "/images/europa/juventus/25-26-01/uni1.png",
      "/images/europa/juventus/25-26-01/uni2.png",
      "/images/europa/juventus/25-26-01/uni3.png",
      "/images/europa/juventus/25-26-01/uni4.png",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2025", "2025 juventus", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/25-26-02/uni0.png",
      "/images/europa/juventus/25-26-02/uni1.png",
      "/images/europa/juventus/25-26-02/uni2.png",
      "/images/europa/juventus/25-26-02/uni3.png",
      "/images/europa/juventus/25-26-02/uni4.png",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2025", "2025 juventus", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/25-26-03/uni0.png",
      "/images/europa/juventus/25-26-03/uni1.png",
      "/images/europa/juventus/25-26-03/uni2.png",
      "/images/europa/juventus/25-26-03/uni3.png",
      "/images/europa/juventus/25-26-03/uni4.png",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2024", "2024 juventus", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/24-25-01/uni0.jpg",
      "/images/europa/juventus/24-25-01/uni1.jpg",
      "/images/europa/juventus/24-25-01/uni2.jpg",
      "/images/europa/juventus/24-25-01/uni3.jpg",
      "/images/europa/juventus/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2024", "2024 juventus", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/24-25-02/uni0.jpg",
      "/images/europa/juventus/24-25-02/uni1.jpg",
      "/images/europa/juventus/24-25-02/uni2.jpg",
      "/images/europa/juventus/24-25-02/uni3.jpg",
      "/images/europa/juventus/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 23/24 - Uniforme 1",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2023", "2023 juventus", "2023"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/23-24-01/uni0.jpg",
      "/images/europa/juventus/23-24-01/uni1.jpg",
      "/images/europa/juventus/23-24-01/uni2.jpg",
      "/images/europa/juventus/23-24-01/uni3.jpg",
      "/images/europa/juventus/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 23/24 - Uniforme 2",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2023", "2023 juventus", "2023"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/23-24-02/uni0.jpg",
      "/images/europa/juventus/23-24-02/uni1.jpg",
      "/images/europa/juventus/23-24-02/uni2.jpg",
      "/images/europa/juventus/23-24-02/uni3.jpg",
      "/images/europa/juventus/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2022", "2022 juventus", "2022"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/22-23-01/uni0.jpg",
      "/images/europa/juventus/22-23-01/uni1.jpg",
      "/images/europa/juventus/22-23-01/uni2.jpg",
      "/images/europa/juventus/22-23-01/uni3.jpg",
      "/images/europa/juventus/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: ["juventus", "juve", "juventus 2021", "2021 juventus", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/21-22-01/uni0.jpg",
      "/images/europa/juventus/21-22-01/uni1.jpg",
      "/images/europa/juventus/21-22-01/uni2.jpg",
      "/images/europa/juventus/21-22-01/uni3.jpg",
      "/images/europa/juventus/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 19/20 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2019",
      "2019 juventus",
      "2019",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/19-20-01-rt/uni0.jpg",
      "/images/europa/juventus/19-20-01-rt/uni1.jpg",
      "/images/europa/juventus/19-20-01-rt/uni2.jpg",
      "/images/europa/juventus/19-20-01-rt/uni3.jpg",
      "/images/europa/juventus/19-20-01-rt/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 15/16 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2015",
      "2015 juventus",
      "2015",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/15-16-03-rt/uni0.jpg",
      "/images/europa/juventus/15-16-03-rt/uni1.jpg",
      "/images/europa/juventus/15-16-03-rt/uni2.jpg",
      "/images/europa/juventus/15-16-03-rt/uni3.jpg",
      "/images/europa/juventus/15-16-03-rt/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 13/14 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2013",
      "2013 juventus",
      "2013",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/13-14-03-rt/uni0.png",
      "/images/europa/juventus/13-14-03-rt/uni1.png",
      "/images/europa/juventus/13-14-03-rt/uni2.png",
      "/images/europa/juventus/13-14-03-rt/uni3.png",
      "/images/europa/juventus/13-14-03-rt/uni4.png",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 12/13 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2012",
      "2012 juventus",
      "2012",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/12-13-02-rt/uni0.jpg",
      "/images/europa/juventus/12-13-02-rt/uni1.jpg",
      "/images/europa/juventus/12-13-02-rt/uni2.jpg",
      "/images/europa/juventus/12-13-02-rt/uni3.jpg",
      "/images/europa/juventus/12-13-02-rt/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 10/11 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2010",
      "2010 juventus",
      "2010",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/10-11-02-rt/uni0.jpeg",
      "/images/europa/juventus/10-11-02-rt/uni1.jpeg",
      "/images/europa/juventus/10-11-02-rt/uni2.jpeg",
      "/images/europa/juventus/10-11-02-rt/uni3.jpeg",
      "/images/europa/juventus/10-11-02-rt/uni4.jpeg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 05/06 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2005",
      "2005 juventus",
      "2005",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/05-06-02-rt/uni0.jpg",
      "/images/europa/juventus/05-06-02-rt/uni1.jpg",
      "/images/europa/juventus/05-06-02-rt/uni2.jpg",
      "/images/europa/juventus/05-06-02-rt/uni3.jpg",
      "/images/europa/juventus/05-06-02-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 05/06 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2005",
      "2005 juventus",
      "2005",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/05-06-03-rt/uni0.jpg",
      "/images/europa/juventus/05-06-03-rt/uni1.jpg",
      "/images/europa/juventus/05-06-03-rt/uni2.jpg",
      "/images/europa/juventus/05-06-03-rt/uni3.jpg",
      "/images/europa/juventus/05-06-03-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 01/02 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 2001",
      "2001 juventus",
      "2001",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/01-02-01-rt/uni0.jpg",
      "/images/europa/juventus/01-02-01-rt/uni1.jpg",
      "/images/europa/juventus/01-02-01-rt/uni2.jpg",
      "/images/europa/juventus/01-02-01-rt/uni3.jpg",
      "/images/europa/juventus/01-02-01-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 99/00 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 1999",
      "1999 juventus",
      "1999",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/99-00-02-rt/uni0.png",
      "/images/europa/juventus/99-00-02-rt/uni1.png",
      "/images/europa/juventus/99-00-02-rt/uni2.png",
      "/images/europa/juventus/99-00-02-rt/uni3.png",
      "/images/europa/juventus/99-00-02-rt/uni4.png",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 1998",
      "1998 juventus",
      "1998",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/98-99-01-rt/uni0.jpg",
      "/images/europa/juventus/98-99-01-rt/uni1.jpg",
      "/images/europa/juventus/98-99-01-rt/uni2.jpg",
      "/images/europa/juventus/98-99-01-rt/uni3.jpg",
      "/images/europa/juventus/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 97/98 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 1997",
      "1997 juventus",
      "1997",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/97-98-01-rt/uni0.jpg",
      "/images/europa/juventus/97-98-01-rt/uni1.jpg",
      "/images/europa/juventus/97-98-01-rt/uni2.jpg",
      "/images/europa/juventus/97-98-01-rt/uni3.jpg",
      "/images/europa/juventus/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 1997",
      "1997 juventus",
      "1997",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/97-98-02-rt/uni0.jpg",
      "/images/europa/juventus/97-98-02-rt/uni1.jpeg",
      "/images/europa/juventus/97-98-02-rt/uni2.jpg",
      "/images/europa/juventus/97-98-02-rt/uni3.jpg",
      "/images/europa/juventus/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 95/96 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus 1995",
      "1995 juventus",
      "1995",
      "juventus retro",
      "retro juventus",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/juventus/95-96-01-rt/uni0.jpg",
      "/images/europa/juventus/95-96-01-rt/uni1.jpg",
      "/images/europa/juventus/95-96-01-rt/uni2.jpeg",
      "/images/europa/juventus/95-96-01-rt/uni3.jpeg",
      "/images/europa/juventus/95-96-01-rt/uni4.jpeg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jb/uni0.jpg",
      "/images/europa/juventus/jb/uni1.jpg",
      "/images/europa/juventus/jb/uni2.jpg",
      "/images/europa/juventus/jb/uni3.jpg",
      "/images/europa/juventus/jb/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jb1/uni0.png",
      "/images/europa/juventus/jb1/uni1.png",
      "/images/europa/juventus/jb1/uni2.png",
      "/images/europa/juventus/jb1/uni3.png",
      "/images/europa/juventus/jb1/uni4.png",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jb2/uni0.jpg",
      "/images/europa/juventus/jb2/uni1.jpg",
      "/images/europa/juventus/jb2/uni2.jpg",
      "/images/europa/juventus/jb2/uni3.jpg",
      "/images/europa/juventus/jb2/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Branca/Preta)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jbp/uni0.jpg",
      "/images/europa/juventus/jbp/uni1.jpg",
      "/images/europa/juventus/jbp/uni2.jpg",
      "/images/europa/juventus/jbp/uni3.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jp/uni0.jpg",
      "/images/europa/juventus/jp/uni1.jpg",
      "/images/europa/juventus/jp/uni2.jpg",
      "/images/europa/juventus/jp/uni3.jpg",
      "/images/europa/juventus/jp/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jp1/uni0.jpg",
      "/images/europa/juventus/jp1/uni1.jpg",
      "/images/europa/juventus/jp1/uni2.jpg",
      "/images/europa/juventus/jp1/uni3.jpg",
      "/images/europa/juventus/jp1/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "juventus",
      "juve",
      "juventus jaqueta",
      "jaqueta juventus",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/juventus/jp2/uni0.jpg",
      "/images/europa/juventus/jp2/uni1.jpg",
      "/images/europa/juventus/jp2/uni2.jpg",
      "/images/europa/juventus/jp2/uni3.jpg",
      "/images/europa/juventus/jp2/uni4.jpg",
    ],
  },
];

export default juventus;
